module.exports = __webpack_public_path__ + "templates-59e97cd7/template-7-cdf52243d4486bb19fea9ae5d857f71c.jpg";